import { Form } from 'components/UIComponents/FormStyles'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import {
  setIsRuleEdited,
  setRuleStaticDetails,
  setSelectedDegreesAndDepartmentsList,
} from '../../action'
import { SectionWrapper, TopFlex, TopHeader } from '../../Style/style'
import {
  convertToNumber,
  formatNumber,
  initialAbsentCount,
  initialCTCRule,
  initialDurationRange,
  initialMaxRolesAllowed,
  initialRoleApplyPermit,
} from '../RuleEngineCommonFunction'
import RuleHeader from '../RuleHeader'
import RulesCreationTable from './RulesCreationTable'
const initialCompensationState = [
  {
    name: 'Regular',
    minCTC: '0',
    maxCTC: '0',
  },
  {
    name: 'Dream',
    minCTC: '0',
    maxCTC: '0',
  },
  {
    name: 'Super Dream',
    minCTC: '0',
    maxCTC: '0',
  },
  {
    name: 'Elite',
    minCTC: '0',
    maxCTC: '0',
  },
]
const fields = [
  'absentCount',
  'maxRolesAllowed',
  'applicationStatusThreshold',
  'roleApplyPermit',
  'ctcRule',
  'brands',
  'gigs',
  'internship',
  'apprenticeship',
]

const initialApplicationThreshold = {
  placementType: '',
  isEnabled: false,
  offerEnabled: '',
  placedLimit: '',
  compensationThreshold: initialCompensationState,
  isAboveMinValue: false,
  minThreshold: '',
  multiplesThreshold: '',
  isMultiples: false,
  isAbsolute: false,
  allowedExceptionBrands: '',
  absoluteThreshold: '',
  isCompensationThreshold: false,
  exceptionBrands: [],
}

export default function RulesCreationIndex({
  getInstituteRulesById,
  updateRules,
  setUpNewRules,
  rulesDegreesMetrics,
  getCorporateListFromCorporate,
  getCorporateList,
}) {
  const params = useParams()
  const currentDate = new Date()
  const rulesDetails = useSelector(state => state?.rules?.ruleDetailsById)
  const rulesStaticDetails = useSelector(
    state => state?.rules?.rulesStaticDetails
  )
  const isRuleEdited = useSelector(state => state?.rules?.isRuleEdited)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [ruleForm] = Form.useForm()
  const [isOpen, setIsOpen] = useState(false)
  const [degreeStreamList, setDegreeStreamList] = useState([])
  const [brandList, setBrandList] = useState([])
  const [removedList, setRemovedList] = useState([])
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState({
    ctcRule: initialCTCRule,
    internship: initialDurationRange,
    gigs: initialDurationRange,
    apprenticeship: initialDurationRange,
    maxRolesAllowed: initialMaxRolesAllowed,
    roleApplyPermit: initialRoleApplyPermit,
    absentCount: initialAbsentCount,
    applicationStatusThreshold: initialApplicationThreshold,
    brands: {
      isEnabled: false,
      brandsList: [],
    },
    status: 0,
    ruleName: '',
  })
  const [successRulePopup, setSuccessRulePopup] = useState(false)

  const onSubmitFormData = (value = state, action = false, ruleStatus = '') => {
    const {
      ctcRule,
      maxRolesAllowed,
      roleApplyPermit,
      absentCount,
      applicationStatusThreshold,
      status,
      ruleName,
      internship,
      gigs,
      apprenticeship,
    } = value
    const degreeStream = degreeStreamList?.map(item => {
      return {
        degreeId: item?.degree?.id,
        streamId: item?.stream?.id,
      }
    })
    try {
      const payload = {
        id: params.ruleId,
        ruleName: ruleName,
        degreeStreamMap: degreeStream,
        brands: {
          list: brandList,
          isEnabled: value?.brands?.isEnabled,
        },
        status: status,
      }
      if (ctcRule?.compensation) {
        payload.ctcRule = {
          ...ctcRule,
          compensation: convertToNumber(ctcRule?.compensation),
        }
      }
      payload.jobCategory = {} // Initialize jobCategory as an empty object

      if (internship && internship.duration) {
        payload.jobCategory.internship = {
          ...internship,
          tenureRange: internship?.tenureRange?.filter(item => item !== null),
        }
      }

      if (gigs && gigs.duration) {
        payload.jobCategory.gigs = { ...gigs }
      }

      if (apprenticeship && apprenticeship.duration) {
        payload.jobCategory.apprenticeship = { ...apprenticeship }
      }

      if (Object.keys(payload.jobCategory).length === 0) {
        delete payload.jobCategory
      }

      if (maxRolesAllowed?.roleCount) {
        payload.maxRolesAllowed = {
          ...maxRolesAllowed,
        }
      }
      if (roleApplyPermit?.roleCount) {
        payload.roleApplyPermit = {
          ...roleApplyPermit,
        }
      }
      if (absentCount?.missedEvaluationCount) {
        payload.absentCount = {
          ...absentCount,
        }
      }

      if (applicationStatusThreshold?.placementType) {
        payload.applicationStatusThreshold = {
          placementType: applicationStatusThreshold?.placementType,
          placedLimit: applicationStatusThreshold?.placedLimit,
          isEnabled: applicationStatusThreshold?.isEnabled,
          ...(typeof applicationStatusThreshold?.offerEnabled === 'boolean' && {
            offerEnabled: applicationStatusThreshold?.offerEnabled,
          }),
          ctcThreshold: {
            minThreshold: convertToNumber(
              applicationStatusThreshold?.minThreshold
            ),
            isMultiples: applicationStatusThreshold?.isMultiples,
            isAbsolute: applicationStatusThreshold?.isAbsolute,
            multiplesThreshold:
              applicationStatusThreshold?.multiplesThreshold || 0,
            absoluteThreshold: convertToNumber(
              applicationStatusThreshold?.absoluteThreshold
            ),
          },
          compensationThreshold: {
            isEnabled: applicationStatusThreshold?.isCompensationThreshold,
            compensationList: applicationStatusThreshold?.compensationThreshold
              ?.filter(
                i =>
                  i.name &&
                  (convertToNumber(i.maxCTC) > 0 ||
                    convertToNumber(i.minCTC) > 0)
              )
              ?.map((item, idex) => {
                return {
                  name: item.name,
                  orderNo: idex + 1,
                  maxCTC: convertToNumber(item.maxCTC) || 0,
                  minCTC: convertToNumber(item.minCTC) || 0,
                  isAboveMinValue:
                    !item.maxCTC && item.minCTC
                      ? applicationStatusThreshold?.isAboveMinValue
                      : false,
                }
              }),
          },
          exceptionBrands: {
            list: applicationStatusThreshold?.exceptionBrands,
            isEnabled: applicationStatusThreshold?.exceptionBrands?.length > 0,
          },
        }
      }
      if (status === 0) {
        payload.effectiveDate = moment().format('YYYY-MM-DD')
      }
      if (ruleStatus === 'published') {
        payload.effectiveDate = moment().format('YYYY-MM-DD')
      }
      dispatchRulesStaticDetails(payload, degreeStreamList)
      if (ruleStatus) {
        updateRule(payload, action, ruleStatus)
      } else {
        setIsOpen(false)
      }
    } catch (err) {
      //console.log(err)
    }
  }

  const updateRule = async (data, action, ruleStatus) => {
    const response = await updateRules(data, params.ruleId)
    if (response?.status === 200) {
      fetchInstituteRulesById(params.ruleId)
      if (action) {
        if (response?.data?.data?.status === 1) {
          setSuccessRulePopup(true)
        }
        if (ruleStatus === 'draft') {
          setTimeout(() => {
            navigate('/ruleEngine/draft-page')
          }, 1000)
        }
        if (ruleStatus === 'published') {
          setSuccessRulePopup(true)
        }
        dispatch(setIsRuleEdited(false))
      } else {
        setIsOpen(false)
      }
    }
  }

  const dispatchRulesStaticDetails = (data, degreeStreamList) => {
    const storedValue = {
      ...data,
      degreeStreamMapId: degreeStreamList,
      ...(data?.applicationStatusThreshold?.placementType && {
        applicationStatusThreshold: {
          ...data?.applicationStatusThreshold,
          ...(data?.applicationStatusThreshold?.placementType && {
            placementType: Array.isArray(
              data.applicationStatusThreshold.placementType
            )
              ? data.applicationStatusThreshold.placementType
              : [data.applicationStatusThreshold.placementType],
          }),
        },
      }),
    }
    dispatch(setRuleStaticDetails(storedValue))
  }

  const fetchInstituteRulesById = async (ruleId, loading, isEdited = false) => {
    try {
      if (loading) {
        setLoading(true)
      }
      let data = {}
      if (isEdited) {
        const details = await getInstituteRulesById(ruleId)
        data = rulesStaticDetails || {}
        data.degreeStreamMapId = details.degreeStreamMapId
        fields?.forEach(field => {
          if (rulesDetails?.[field]) {
            data[field] = data[field] || {}
            data[field].isEnabled = state[field]?.isEnabled
          }
        })
      } else {
        data = await getInstituteRulesById(ruleId)
      }
      setLoading(false)
      dispatchRulesStaticDetails(data, data?.degreeStreamMapId)

      setDegreeStreamList(data?.degreeStreamMapId || [])
      setBrandList(data?.brands?.list || [])
      const setFieldValueAndState = (key, value) => {
        if (value) {
          ruleForm.setFieldsValue({ [key]: value })
          return { [key]: value }
        }
        return {}
      }
      const ctcRule = data?.ctcRule?.compensation
        ? {
            compensation: formatNumber(data.ctcRule.compensation),
            isEnabled: data.ctcRule.isEnabled,
            closestCtcRate: data.ctcRule.closestCtcRate,
            allowClosestCTC: data.ctcRule.allowClosestCTC,
          }
        : initialCTCRule

      const roleApplyPermit = data?.roleApplyPermit?.roleCount
        ? data.roleApplyPermit
        : initialRoleApplyPermit
      const maxRolesAllowed = data?.maxRolesAllowed?.roleCount
        ? data.maxRolesAllowed
        : initialMaxRolesAllowed
      const absentCount = data?.absentCount?.missedEvaluationCount
        ? data.absentCount
        : initialAbsentCount
      const applicationStatusThreshold =
        data?.applicationStatusThreshold?.placementType?.length > 0
          ? {
              placementType: data?.applicationStatusThreshold?.placementType[0],
              isEnabled: data?.applicationStatusThreshold?.isEnabled,
              isAboveMinValue:
                !data?.applicationStatusThreshold?.compensationThreshold?.compensationList?.every(
                  item =>
                    convertToNumber(item.maxCTC) > 0 &&
                    convertToNumber(item.minCTC) > 0
                ),
              compensationThreshold:
                data?.applicationStatusThreshold?.compensationThreshold
                  ?.compensationList?.length > 0
                  ? data?.applicationStatusThreshold?.compensationThreshold?.compensationList?.map(
                      item => ({
                        ...item,
                        maxCTC: formatNumber(item.maxCTC),
                        minCTC: formatNumber(item.minCTC),
                      })
                    )
                  : initialCompensationState,
              isCompensationThreshold:
                data?.applicationStatusThreshold?.compensationThreshold
                  ?.isEnabled,
              minThreshold:
                formatNumber(
                  data?.applicationStatusThreshold?.ctcThreshold?.minThreshold
                ) || 0,
              multiplesThreshold:
                data?.applicationStatusThreshold?.ctcThreshold
                  ?.multiplesThreshold,
              isMultiples:
                data?.applicationStatusThreshold?.ctcThreshold?.isMultiples,
              isAbsolute:
                data?.applicationStatusThreshold?.ctcThreshold?.isAbsolute,
              allowedExceptionBrands: '',
              absoluteThreshold:
                formatNumber(
                  data?.applicationStatusThreshold?.ctcThreshold
                    ?.absoluteThreshold
                ) || 0,
              placedLimit: data?.applicationStatusThreshold?.placedLimit,
              offerEnabled:
                typeof data?.applicationStatusThreshold?.offerEnabled ===
                'boolean'
                  ? data?.applicationStatusThreshold?.offerEnabled
                  : '',
              exceptionBrands:
                data?.applicationStatusThreshold?.exceptionBrands?.list || [],
            }
          : initialApplicationThreshold

      const internship = {
        isEnabled: data?.jobCategory?.internship?.isEnabled,
        duration: data?.jobCategory?.internship?.duration || 0,
        tenureRange: data?.jobCategory?.internship?.tenureRange,
      }

      const gigs = {
        isEnabled: data?.jobCategory?.gigs?.isEnabled,
        duration: data?.jobCategory?.gigs?.duration || 0,
        tenureRange: data?.jobCategory?.gigs?.tenureRange,
      }

      const apprenticeship = {
        isEnabled: data?.jobCategory?.apprenticeship?.isEnabled,
        duration: data?.jobCategory?.apprenticeship?.duration || 0,
        tenureRange: data?.jobCategory?.apprenticeship?.tenureRange,
      }

      const brands = {
        isEnabled: data?.brands?.isEnabled,
        brandsList: data?.brands?.list || [],
      }

      const newState = {
        ...setFieldValueAndState('ctcRule', ctcRule),
        ...setFieldValueAndState('roleApplyPermit', roleApplyPermit),
        ...setFieldValueAndState('maxRolesAllowed', maxRolesAllowed),
        ...setFieldValueAndState('absentCount', absentCount),
        ...setFieldValueAndState(
          'applicationStatusThreshold',
          applicationStatusThreshold
        ),
        ...setFieldValueAndState('status', data?.status),
        ...setFieldValueAndState(
          'internship',
          data?.jobCategory?.internship?.duration
            ? internship
            : initialDurationRange
        ),
        ...setFieldValueAndState(
          'gigs',
          data?.jobCategory?.gigs?.duration ? gigs : initialDurationRange
        ),
        ...setFieldValueAndState(
          'apprenticeship',
          data?.jobCategory?.apprenticeship?.duration
            ? apprenticeship
            : initialDurationRange
        ),
        ...(data?.ruleName &&
          setFieldValueAndState('ruleName', data?.ruleName)),
        ...setFieldValueAndState('brands', brands),
      }
      setState(prevState => ({
        ...prevState,
        ...newState,
      }))
    } catch (err) {
      //console.log(err)
    }
  }

  useEffect(() => {
    if (params.ruleId) {
      fetchInstituteRulesById(params.ruleId, true, false)
    }
  }, [params])

  useEffect(() => {
    setUpNewRules()
  }, [])

  const handleSpecificSwitchChange = (checked, value) => {
    const updatedState = {
      ...state,
      [value]: {
        ...state[value],
        isEnabled: checked,
      },
    }
    setState(updatedState)
  }

  const handleSubmit = status => {
    const updatedState = {
      ...state,
      status: status,
    }
    setState(updatedState)
    onSubmitFormData(
      updatedState,
      true,
      status === 1 ? 'published' : status === 0 ? 'draft' : ''
    )
  }

  const handleRemove = id => {
    const removedData = degreeStreamList?.filter(item => item.id !== id)
    let dataArr = [
      ...removedList,
      ...(degreeStreamList?.filter(item => item.id === id) || []),
    ]
    setRemovedList(dataArr)
    const action = setSelectedDegreesAndDepartmentsList({
      check: true,
      list: dataArr,
    })
    dispatch(action)
    setDegreeStreamList(removedData)
  }
  const handleBackApplyClick = () => {
    navigate(`/ruleEngine/setting-new-rule/${params.ruleId}`)
    dispatch(setIsRuleEdited(true))
  }

  return (
    <SectionWrapper>
      <TopHeader row spaceBetween alignCenter>
        <TopFlex column>
          <RuleHeader cardData={rulesDegreesMetrics} />
          <Form
            scrollToFirstError
            onFinish={() => onSubmitFormData(state)}
            id={'rulesForm'}
            form={ruleForm}
            layout="vertical"
            initialValues={state}
          >
            <div>
              <RulesCreationTable
                state={state}
                setState={setState}
                ruleForm={ruleForm}
                getCorporateList={getCorporateListFromCorporate}
                degreeStreamList={degreeStreamList}
                setBrandList={setBrandList}
                brandList={brandList}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                handleSpecificSwitchChange={handleSpecificSwitchChange}
                // rulesDetails={rulesDetails}
                rulesDetails={rulesStaticDetails}
                handleRemove={handleRemove}
                handleSubmit={handleSubmit}
                ruleDate={rulesDetails.effectiveDate || currentDate}
                fetchInstituteRulesById={fetchInstituteRulesById}
                ruleId={params.ruleId}
                getListOfCompanies={getCorporateList}
                setSuccessRulePopup={setSuccessRulePopup}
                successRulePopup={successRulePopup}
                loading={loading}
                handleBackApplyClick={handleBackApplyClick}
              />
            </div>
          </Form>
        </TopFlex>
      </TopHeader>
    </SectionWrapper>
  )
}
